<template>
  <div class="media-container">
    <img v-if="this.isImage(imageLink)" class="post-media" :src="imageLink"/>
    <video v-else autoplay loop muted class="post-media" :src="imageLink"/>
  </div>
</template>

<script>   
import isImage from "is-image";

export default {
  name: "PostMedia",
  methods: {
    isImage,
  },
  props: {},              
  data: () => ({
    imageLink: '/test-media/openai.png'
  }),
};
</script>

<style scoped>
.media-container {
  width: 100%;
  /* display: flex;
  flex-grow: 1; */
}
.post-media {
  max-width: 100%;
  margin: 0 auto;
}
</style>                                     